<template>
  <div>
    <div class="small__header container-fluid clearfix">
      <section class="">
        <a
          class="header__switch"
          id="oldQtLink"
          target="_self"
          href="https://legacy.irecharge.ng/"
          >Switch to Old iRecharge</a
        >
        <a
          class="nav-link text-white animated flash tada delay-3s mobile_phone"
          href="tel:08149906336"
        >
          <i class="fa fa-phone"></i> 0814 990 6336
        </a>
        <a
          class="header__switch__mobile"
          id="mobileOldQtLink"
          target="_self"
          href="https://old.irecharge.ng/"
          >Old iRecharge</a
        >
      </section>
      <section class="header__account" id="topBarHeaderAccount">
        <span class="smallnav__title">
          <a
            class="nav-link text-white animated flash tada delay-3s"
            href="tel:08149906336"
          >
            <i class="fa fa-phone"></i> 0814 990 6336
          </a>
          <a
            class="nav-link text-white animated flash tada delay-3s"
            @click="whatsApp"
            style="cursor: pointer"
          >
            <i class="fa fa-whatsapp"></i> 0903 000 9930
          </a>
          <router-link
            to="/request_token"
            class="nav-link text-white modal-trigger animated flash infinite delay-5s"
          >
            Lost your token?
          </router-link>
        </span>
      </section>
    </div>
    <header class="header container-fluid  clearfix" id="topBarHeader">
      <section class="header__logo">
        <a
          id="qtLogo"
          class="header__logo"
          href="/"
          style="background-image: url('ui/img/irecharge.png');"
        ></a>
        <div class="container navBtn sidenav-trigger" data-target="slide-out">
          <div class="bar1"></div>
          <div class="bar2"></div>
          <div class="bar3"></div>
        </div>
        <!-- <a href="#" data-target="slide-out" class="sidenav-trigger"><i class="material-icons">menu</i></a> -->
      </section>
      <section class="header__account" id="topBarHeaderAccount">
        <section class="account" id="account">
          <section class="header__account__buttons">
            <!-- UserType 2 = Guest, userType 1 = Registered User -->
            <section id="account" v-if="userType == 2">
              <button
                class="waves-effect btn btn__login"
                @click="login('login')"
                style="background-color: #fff"
              >
                Login
              </button>
              <button
                class="waves-effect btn btn__signup space--left"
                @click="login('signup')"
              >
                Sign Up
              </button>
            </section>
            <section id="account" v-else>
              <button
                class="waves-effect btn btn__login"
                @click="dashboard('profile')"
                style="background-color: #fff"
              >
                Dashboard
              </button>
              <button
                class="waves-effect btn btn__signup space--left"
                @click="dashboard('logout')"
              >
                Logout
              </button>
            </section>
          </section>
        </section>
      </section>
    </header>
  </div>
</template>
<script>
export default {
  mounted() {
    if (localStorage.getItem('status') != 1) {
      this.userType = 2
    } else {
      this.getUserType()
    }
  },
  data() {
    return {
      userType: ''
    }
  },
  methods: {
    login(option) {
      document.getElementById('myNav').style.width = '100%'
      this.$emit('modal-option', option)
    },
    getUserType() {
      this.userType = localStorage.getItem('userType')
    },
    dashboard(option) {
      if (option == 'logout') {
        // localStorage.setItem('userType', 2)
        // localStorage.removeItem('status')
        // localStorage.removeItem('attempts')
        // sessionStorage.removeItem('status')
        // localStorage.removeItem('tv')
        // localStorage.removeItem('power')
        // localStorage.removeItem('data')
        // localStorage.removeItem('airtime')
        // localStorage.removeItem('expire')
        // localStorage.removeItem('timestamp')
        // localStorage.removeItem('email')
        // localStorage.removeItem('user')
        window.location.assign('signout.php')
      }
      if (option == 'profile') {
        window.location.assign('profile.php')
      }
    },
    whatsApp() {
      window.open(
        'https://api.whatsapp.com/send?phone=09030009930&text=How%20may%20we%20help%20you%20today%20',
        '_blank'
      )
    }
  }
}
</script>
<style scoped>
.text-white {
  color: #fff;
}
.mobile_phone {
  display: none;
}
@media only screen and (max-width: 600px) {
  .mobile_phone {
    display: block;
    float: right;
  }
}
</style>
